// extracted by mini-css-extract-plugin
export default {"title":"title_title__97X12","title_name":"title_title_name__Z3E4R"};